package fr.arcplex.network.model

/**
 * Answer to one search query: the rail named by [targetId] must be replaced
 * with [items]. [targetId] is null when the answer was stale or was not a
 * `refreshLine` answer, in which case nothing must change.
 */
data class SearchPage(
    val targetId: String?,
    val items: List<RailItem>
)
